import { createAction } from 'redux-actions'

const REMOVE_SINGLE_GUEST_FROM_SAIL = 'EDIT_TICKET:REMOVE_SINGLE_GUEST_FROM_SAIL'

export const removeSingleGuest = createAction(REMOVE_SINGLE_GUEST_FROM_SAIL)
